/**
 * All thresholds here are configurable operational settings, not clinical guidelines.
 * They exist to route pharmacist attention, never to trigger therapy changes on their own.
 */
export interface ClinicalFlagConfig {
  /** Active medication count at or above this triggers a POLYPHARMACY flag. */
  polypharmacyThreshold: number;
  /** Days before a follow-up's due date it becomes a FOLLOW_UP_DUE flag. */
  followUpDueWindowDays: number;
  /** MRP severities that trigger a HIGH_PRIORITY_REVIEW flag when unresolved. */
  highPrioritySeverities: Array<"HIGH" | "CRITICAL">;
}

export const DEFAULT_CLINICAL_FLAG_CONFIG: ClinicalFlagConfig = {
  polypharmacyThreshold: 5,
  followUpDueWindowDays: 3,
  highPrioritySeverities: ["HIGH", "CRITICAL"],
};
